import { Controller } from "@hotwired/stimulus"

// Cmd+Enter (Ctrl+Enter elsewhere) sends the form — the usual shortcut for
// "send" in a multi-line message box, where Enter alone makes a new line.
export default class extends Controller {
  submit(event) {
    event.preventDefault()
    this.element.requestSubmit()
  }
}
